import { APP_MANAGER_ACCESS_ROLES } from "./config";
import { FeatureFlagKey } from "./feature-flags";
import { ROUTES } from "./routes";
import { TIconName } from "@/design-tokens";
import { TUserRole } from "@/types";

/**
 * Navigation constant interface.
 * Defines the structure for navigation items before they are processed.
 */
interface INavConstant {
  ariaLabel?: string;
  featureFlag: FeatureFlagKey[];
  icon: TIconName;
  label: string;
  roles: TUserRole[];
  route: string;
}

/**
 * All possible clickable navigation items in the application.
 */
export const ALL_NAV_ITEMS: INavConstant[] = [
  {
    ariaLabel: 'Sales Rep Dashboard Page',
    featureFlag: ['ENABLE_SALES_REP_DASHBOARD'],
    icon: 'House',
    label: 'Dashboard',
    roles: [],
    route: ROUTES.SALES_REP_DASHBOARD,
  },
  {
    ariaLabel: 'User Profile Page',
    featureFlag: ['ENABLE_USER_PROFILE_PAGE'],
    icon: 'User',
    label: 'Profile',
    roles: [],
    route: ROUTES.USER_PROFILE,
  },
  {
    ariaLabel: 'Manager Dashboard Page',
    featureFlag: ['ENABLE_MANAGER_DASHBOARD'],
    icon: 'Users',
    label: 'Team Dashboard',
    roles: APP_MANAGER_ACCESS_ROLES,
    route: ROUTES.MANAGER_DASHBOARD,
  },
  {
    ariaLabel: 'Manager Analytics Page',
    featureFlag: ['ENABLE_MANAGER_DASHBOARD', 'ENABLE_MANAGER_ANALYTICS'],
    icon: 'ListChecks',
    label: 'Analytics',
    roles: APP_MANAGER_ACCESS_ROLES,
    route: ROUTES.MANAGER_ANALYTICS,
  },
  {
    ariaLabel: 'Logout of the application',
    featureFlag: [],
    icon: 'SignOut',
    label: 'Sign Out',
    roles: [],
    route: ROUTES.LOGOUT,
  },
] as const;
